import React from 'react'
import * as additionalDocumentType from './additionalDocumentType'

import arrayMutators from 'final-form-arrays'
import NumberOfDoc from '../../../shareUI/numberOfDoc2/numberOfDoc'
import useAdditionDocument from './useAdditionDocument'
import Dialog from '../../../../../control/dialog/dialog'
import PageAction from '../pageAction'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../i18n/useTranslate'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'

import { Form, FormRenderProps, FormSpy } from 'react-final-form'
import { Grid } from '@material-ui/core'

const AdditionalDocumentREC2View: React.FC<additionalDocumentType.AdditionalDocumentViewType> = (props) => {
    const {
        isViewMode,
        initialValues,
        configDialog,
        disabledField,
        requiredField,
        isShowUpdateDate,
        onRefDialog,
        onSubmitForm,
        funcCallBack,
        onClickCancel,
        onDirtyChange,
    } = props
    const snackbarAction = useSnackbarAction()
    const translate = useTranslate()

    const renderSnackbar = (props: FormRenderProps) => {
        const { values } = props

        const isRequireDoc = values?.requireDoc?.value ?? 'null'
        const isDocumentNumber = values?.documentNumber
        const isSendDocumentDate = values?.sendDocumentDate

        if (isRequireDoc === 'null') {
            snackbarAction.openSnackbar({
                message: translate.get('MESSAGE.M012'),
                type: 'error',
            })
        }

        if (isRequireDoc === '1') {
            ;(!isSendDocumentDate || !isDocumentNumber) &&
                snackbarAction.openSnackbar({
                    message: translate.get('MESSAGE.M012'),
                    type: 'error',
                })
        }
    }

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                const { form, handleSubmit, dirty } = props
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <NumberOfDoc
                                    callbackFunc={funcCallBack}
                                    disabledFieldNames={disabledField}
                                    requiredFieldNames={requiredField}
                                />
                            </Grid>
                            {isShowUpdateDate && <DisplayUpdater />}
                        </Grid>
                        {!isViewMode && (
                            <Grid item xs={12}>
                                <PageAction
                                    onClickClose={() => {
                                        onClickCancel(dirty)
                                    }}
                                    onClickSave={() => {
                                        form.change('submitType', 'save')
                                        handleSubmit()
                                        renderSnackbar(props)
                                    }}
                                    onClickSaveDraft={() => {
                                        form.change('submitType', 'draft')
                                        handleSubmit()
                                    }}
                                />
                            </Grid>
                        )}
                        <FormSpy subscription={{ values: true }} onChange={onDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

const AdditionalDocumentREC2: React.FC<additionalDocumentType.AdditionalDocumentType> = (props) => {
    const useAdditionDocumentModel = useAdditionDocument(props)
    return <AdditionalDocumentREC2View {...useAdditionDocumentModel} {...props} />
}

export default AdditionalDocumentREC2
